import { render, staticRenderFns } from "./WText.vue?vue&type=template&id=46432e08&scoped=true"
import script from "./WText.vue?vue&type=script&lang=js"
export * from "./WText.vue?vue&type=script&lang=js"
import style0 from "./WText.vue?vue&type=style&index=0&id=46432e08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46432e08",
  null
  
)

export default component.exports